import { Link } from 'react-router-dom';
import { Plus, Calendar, Kanban, Users, type LucideIcon } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface QuickAction {
  label: string;
  href: string;
  icon: LucideIcon;
  primary?: boolean;
}

const quickActions: QuickAction[] = [
  {
    label: 'Nueva Cita',
    href: '/bookings/new',
    icon: Plus,
    primary: true,
  },
  {
    label: 'Ver Citas',
    href: '/bookings',
    icon: Calendar,
  },
  {
    label: 'Trabajos',
    href: '/jobs',
    icon: Kanban,
  },
  {
    label: 'Clientes',
    href: '/customers',
    icon: Users,
  },
];

export function QuickActions() {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {quickActions.map((action) => {
        const Icon = action.icon;
        return (
          <Link
            key={action.href}
            to={action.href}
            className={cn(
              'inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
              action.primary
                ? 'bg-blue-600 text-white hover:bg-blue-700'
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 hover:border-gray-300'
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {action.label}
          </Link>
        );
      })}
    </div>
  );
}
